
import { mapGetters, mapState } from "vuex";
import { Component, Vue, Watch } from "vue-property-decorator";
import Subject from "@/models/Subject";

@Component({
  computed: {
    ...mapGetters("BrochureAanvraag", ["subjectsByName"]),
    ...mapState("BrochureAanvraag", ["loading"])
  }
})
export default class SubjectFilter extends Vue {
[x: string]: any;
  selected: string[] = [];

  @Watch("selected")
  selectionChanged(selectedIds: string[]) {

    this.$store.commit("BrochureAanvraag/filterChanged", {
      type: "subjects",
      values: selectedIds
    });
    this.$store.commit("BrochureAanvraag/recalculateFilters");
  }

  GetLabel(value: Subject): string {
    return value.name + " (" + value.count + ")";
  }
}
